import { CONFIG } from "./const";
import DISTRICTS from "./bd/districts.json";
import UPAZILAS from "./bd/upazilas.json";
import UNIONS from "./bd/unions.json";

export const columnSum = (array, columnName) => {
  if (!(array && columnName)) {
    return 0;
  }

  let sum = array.reduce((prev, cur) => {
    return prev + cur[columnName];
  }, 0);

  return sum;
};

export const absBalance = (balanceAmount = 0) => {
  return balanceAmount >= 0 ? balanceAmount : `(${Math.abs(balanceAmount)})`;
};

export const getTV = (data = [], settingsObj = {}) => {
  const { textField = 'text', valueField = 'value', deselectText = '-- Not Selected --', isDeselect = true } = settingsObj;

  let deselectITtem = isDeselect === true ? [{ text: deselectText, value: "" }] : [];
  const dataTV = data.map(r => ({ text: r[textField], value: r[valueField] }));

  return [...deselectITtem, ...dataTV];
};

export const districtTV = (division_id = 0) => {
  let dis = DISTRICTS;
  if(division_id && division_id > 0){
    dis = DISTRICTS.filter(r => r.division_id == division_id);
  }
  return getTV(dis, {textField: "name", valueField: "id", isDeselect: false}).map(r => ({...r, value: Number(r.value)}));
};

export const upazilaTV = (district_id = 0) => {
  let uzilas = UPAZILAS;
  if(district_id && district_id > 0){
    uzilas = UPAZILAS.filter(r => r.district_id == district_id);
  }
  return getTV(uzilas, {textField: "name", valueField: "id", isDeselect: false}).map(r => ({...r, value: Number(r.value)}));
};

export const unionTV = (upazilla_id = 0) => {
  let unions = UNIONS;
  if(upazilla_id && upazilla_id > 0){
    unions = UNIONS.filter(r => r.upazilla_id == upazilla_id);
  }
  return getTV(unions, {textField: "name", valueField: "id", isDeselect: false}).map(r => ({...r, value: Number(r.value)}));
};

export const removeEmptyProps = (obj, fieldsTobeChecked = []) => {
  for (var propName in obj) {
    if (fieldsTobeChecked.length > 0 && !fieldsTobeChecked.includes(propName)) {
      continue;
    }

    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
      delete obj[propName];
    }
  }
  return obj
}

export const valueToText = (TVarray = [], value = "") => {
  const item = TVarray.find(r => r.value == value);
  return item && item.text ? item.text : "";
}

export const hasPerm = ( permissionKey = "", userTypes = []) => {
  const { permissions } = CONFIG;
  return (permissions[permissionKey] || []).filter(type => userTypes.includes(type)).length > 0 ? true : false;
}
